import { useTranslation } from 'react-i18next';
import { useSetAtom } from 'jotai';

import imgDivider from '@/assets/svg/ai-enhancement-header-divider.svg';
import imgAIIntro from '@/assets/svg/ai-enhancement-intro.svg';
import {
  IntroFooter,
  IntroHeader,
  IntroLogo,
  IntroModal,
  IntroText,
} from '@/features/enhance-common/styles/enhance-modal.styles';
import { modalState } from '@/state/modal.state';
import { colors } from '@/theme/colors';
import { Button } from '@/ui/button/button';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { Stack } from '@/ui/line/line';

export const AutoEnhanceIntroModal = () => {
  const { t } = useTranslation(['projects', 'default']);
  const setModalState = useSetAtom(modalState);

  const handleNext = () => {
    setModalState({ state: 'autoEnhanceConfig' });
  };

  return (
    <IntroModal
      CustomHeaderComponent={IntroHeader}
      header={t('autoEnhanceIntroHeader')}
      outsideClose={false}
    >
      <Stack>
        <img src={imgDivider} alt="" />
        <Flexbox name="enhance-intro-body" height="270px">
          <Stack margin="30px 0px 0px 0px" gap="30px" maxWidth="540px">
            <IntroText>{t('autoEnhanceIntroText1')}</IntroText>
            <IntroText>{t('autoEnhanceIntroText2')}</IntroText>
          </Stack>
          <IntroLogo src={imgAIIntro} alt="" />
        </Flexbox>
        <IntroFooter name="enhance-intro-footer" justify="flex-end">
          <Button
            data-testid="auto-enhance-intro-next"
            endIcon="ArrowRight"
            height={32}
            iconColor={colors.basics.white}
            onClick={handleNext}
            variant="primary"
          >
            {t`default:next`}
          </Button>
        </IntroFooter>
      </Stack>
    </IntroModal>
  );
};
